import React from 'react';
import Chart from "chart.js/auto";
import { Line } from 'react-chartjs-2';
import ManualScroll from './ManualScroll'

//-------------------------------------------

import PieChart from './PieChart';
import LineChart from './LineChart';

//Chart.register(CategoryScale);



function ClientBatteriesCode(){



    return (
       
        <>
          <div class="row">
            <div class="col-sm-6">



          <div className="card" style={{width: "18rem;"}}>
          <div className="card-body">
    <div style={{display: "flex"}}>
    <p className="card-title"><strong>Information</strong></p><span className='info leftAling'><span class="material-symbols-rounded">more_horiz</span></span></div>

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Z-Range </strong>Battery</span>
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Battery Installed: </strong>12 June 2013</span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}>
    
    <span class="material-symbols-rounded writing" >battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Battery nominal capacity [kWh]: </strong><span style={{ color:"#e5603c",}}>5.120</span></span>

    <span class="material-symbols-rounded writing" style={{paddingLeft:"5px"}}>battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px"}}><strong>Cell Amount: </strong><span style={{ color:"#e5603c",}}>16</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}>
    
    <span class="material-symbols-rounded writing">bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Module Voltage [V]: </strong><span style={{ color:"#e5603c",}}>51,2 V DC Nominal</span></span>

    <span class="material-symbols-rounded writing"  style={{paddingLeft:"5px"}}>battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px"}}><strong>Nominal energy [A] </strong><span style={{ color:"#e5603c",}}>100</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}>
    
    <span class="material-symbols-rounded writing">bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Discharging cut-off voltage [LVD]  </strong><span style={{ color:"#e5603c",}}>48V</span></span>

    <span class="material-symbols-rounded writing"  style={{paddingLeft:"5px"}}>local_shipping</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px"}}><strong>Transport </strong><span style={{ color:"#e5603c",}}>UN 3480, CE</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">Lan</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Communication </strong><span style={{ color:"#e5603c",}}>RS485/RS232/CAN</span></span>
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Protection class  </strong><span style={{ color:"#e5603c",}}>IP55</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">local_shipping</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Maximum discharge current </strong><span style={{ color:"#e5603c",}}>1C</span></span>
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Design life  </strong><span style={{ color:"#e5603c",}}>3500 cycle</span></span>
    </div>
    <hr />



   
   <div className='d-flex'>
     <p><strong><span class="material-symbols-rounded writing" >battery_5_bar</span><span style={{width:"20px"}}>System Capicity </span></strong></p>
     <p className='Font-primary' ><strong>&nbsp; 5 kWh</strong></p>
   </div>


   
   {/* 

   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Last 24h: </strong></span>

   <p className='m-auto Font-primary'>-3.1 ℃ Min</p> 
   <p className='m-auto Font-primary'>4.5 ℃ Max</p>
    
    </div>
*/}

  </div>
</div>



</div>




<div class="col-sm-6">



<div className="card" style={{width: "18rem;", marginBottom: "30px"}}>
  <div className="card-body">
    <div style={{display: "flex"}}>
    <p className="card-title"><strong>Manuals</strong></p> <span className='info leftAling'><span class="material-symbols-rounded">more_horiz</span></span></div>

   
<div className='d-flex'>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">menu_book</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Release Note | Spec Sheet | Warranty Statement </strong></span>

    
    </div>

    
  </div>
    <hr />

<ManualScroll />



  </div>
</div>


</div>



          </div>


          {/* Id 0x35C*/}

        </>
    )
}

export default ClientBatteriesCode;